import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button, Modal, Form, Offcanvas } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';
import CreatableSelect from 'react-select/creatable';
import { FaPlus } from 'react-icons/fa';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/overtime-request`;


const OvertimeList = () => {
  const [overtimes, setovertimes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: "", description: "" });
  const [isEdit, setIsEdit] = useState(false);
  const [selectedovertime, setSelectedovertime] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const debounceTimeoutRef = useRef(null);

  const WithEditPermission = withPermission(({ children }) => children, ["overtime-edit"]);
  const WithDeletePermission = withPermission(({ children }) => children, ["overtime-delete"]);
  const WithCreatePermission = withPermission(({ children }) => children, ["overtime-create"]);
  const [employees, setEmployees] = useState([]);
    const [types, setTypes] = useState([]);


  useEffect(() => {
    if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
    debounceTimeoutRef.current = setTimeout(() => {
      fetchovertimes(1, searchQuery);
    }, searchQuery ? 1500 : 0);

    return () => {
      if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
    };
  }, [searchQuery]);

  const fetchovertimes = async (page = 1) => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("user-info"));
      const origin = localStorage.getItem("user-origin");
      const token = userInfo?.token;

      const response = await axios.get(API_URL, {
        headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
        params: { page, search: searchQuery },
      });

      setovertimes(response.data.data || []);
      setPageCount(response.data.data.last_page);
      setCurrentPage(response.data.data.current_page);
    } catch (error) {
      console.error("Error fetching overtimes:", error);
    }
  };
  const fetchEmployees = async () => {
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const origin = localStorage.getItem("user-origin");
    const token = userInfo?.token;

    try {
      const response = await axios.get(`${backendUrl}/api/employee`, {
        headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
      });
      setEmployees(response.data.data || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };
  const fetchTypes = async () => {
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const origin = localStorage.getItem("user-origin");
    const token = userInfo?.token;

    try {
      const response = await axios.get(`${backendUrl}/api/overtime-type`, {
        headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
      });
      setTypes(response.data.data || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };
  useEffect(() => {
  if (showModal) {
    fetchEmployees();
    fetchTypes();
    }
}, [showModal]);


  const handleAddovertime = () => {
    setFormData({ employee_id: "", overtimee_type_id: "",date:"",hours:"",reason:"" });
    setIsEdit(false);
    setSelectedovertime(null);
    setShowModal(true);
    setErrors({});
  };

  const handleEditovertime = (overtime) => {
  setFormData({
    employee_id: overtime.employee_id,
    overtime_type_id: overtime.overtime_type_id,
    hours: overtime.hours,
    date: overtime.date ? overtime.date.split("T")[0] : "", // ✅ format here
    reason: overtime.reason,
  });
  setIsEdit(true);
  setSelectedovertime(overtime);
  setShowModal(true);
  setErrors({});
};


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

const validateForm = () => {
    const newErrors = {};
    if (!formData.employee_id) newErrors.employee_id = "Employee is required";
        if (!formData.overtime_type_id) newErrors.overtime_type_id = "Type is required";

    if (!formData.date) newErrors.date = "Date is required";
    if (!formData.hours) newErrors.hours = "Hours are required";
    return newErrors;
  };

  const handleSubmit = async () => {
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const origin = localStorage.getItem("user-origin");
    const token = userInfo?.token;
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      if (isEdit && selectedovertime?.id) {
        const response = await axios.put(`${API_URL}/${selectedovertime.id}`, formData, {
          headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
        });

        setovertimes(
          overtimes.map((item) => (item.id === selectedovertime.id ? response.data.data : item))
        );
      } else {
        const response = await axios.post(API_URL, formData, {
          headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
        });

        setovertimes([...overtimes, response.data.data]);
      }

      setShowModal(false);
    } catch (error) {
      console.error("Error saving overtime:", error);
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const userInfo = JSON.parse(localStorage.getItem("user-info"));
          const origin = localStorage.getItem("user-origin");
          const token = userInfo?.token;

          await axios.delete(`${API_URL}/${id}`, {
            headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
          });

          setovertimes(overtimes.filter((item) => item.id !== id));
          Swal.fire("Deleted!", "The overtime has been deleted.", "success");
        } catch (error) {
          console.error("Error deleting overtime:", error);
          Swal.fire("Error!", "Failed to delete overtime.", "error");
        }
      }
    });
  };

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    setCurrentPage(newPage);
    fetchovertimes(newPage);
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="row w-100">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">overtime</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between mb-3">
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <input
                          type="text"
                          className="form-control font-size-12"
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                    <WithCreatePermission>
                      <button
                        type="button"
                        className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                        onClick={handleAddovertime}
                        data-bs-toggle="tooltip"
                        title="Add overtime"
                      >
                        <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                      </button>
                    </WithCreatePermission>
                  </div>

                  <table className="table align-middle table-nowrap table-check table-list">
                    <thead className="table-sales-gradient">
                      <tr>
                        <th style={{ width: "20px" }}></th>
                        <th>#</th>
                         <th>Date</th>
                        <th>Employee</th>
                       <th>Overtime Type</th>
                       <th>Rate</th>
                        <th>Hours</th>
                        <th>Reason</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {overtimes.length > 0 ? (
                        overtimes.map((item, index) => (
                          <tr key={item.id}>
                            <td></td>
                            <td>{index + 1}</td>
                    <td>{item.date ? new Date(item.date).toLocaleDateString() : ""}</td>
                                                <td>{item.employee?.first_name} {item.employee?.last_name}</td>
<td>{item.overtime_type?.name}</td>
<td>{item.rate}</td>

                    <td>{item.hours}</td>
                    <td>{item.reason}</td>
                    <td>
                      <span className={`badge bg-${item.status === "approved" ? "success" : item.status === "rejected" ? "danger" : "warning"}`}>
                        {item.status}
                      </span>
                    </td>
                            <td>
                              <div className="dropdown">
                                <i
                                  className="mdi mdi-dots-horizontal font-size-18"
                                  data-bs-toggle="dropdown"
                                  style={{ cursor: "pointer" }}
                                ></i>
                                <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                  <li>
                                    <WithEditPermission>
                                      <button className="dropdown-item" onClick={() => handleEditovertime(item)}>
                                        Edit
                                      </button>
                                    </WithEditPermission>
                                  </li>
                                  <li>
                                    <WithDeletePermission>
                                      <button className="dropdown-item" onClick={() => handleDelete(item.id)}>
                                        Delete
                                      </button>
                                    </WithDeletePermission>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No overtimes found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <div className="d-flex justify-content-end pagination-sm">
                    <ReactPaginate
                      previousLabel={"<"}
                      nextLabel={">"}
                      breakLabel={"..."}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination pagination-rounded justify-content-end mb-2"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  </div>

                  {/* Add/Edit Modal */}
                  <Offcanvas show={showModal} onHide={() => setShowModal(false)} placement="end" style={{ width: "480px" }}>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>{isEdit ? "Edit Overtime Request" : "Add Overtime Request"}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Employee</Form.Label>
                  <Form.Select
                    name="employee_id"
                    value={formData.employee_id}
                    onChange={handleInputChange}
                    className={errors?.employee_id ? "is-invalid" : ""}
                  >
                    <option value="">Select Employee</option>
                    {employees.map((emp) => (
                      <option key={emp.id} value={emp.id}>
                        {emp.first_name} {emp.last_name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.employee_id && <div className="invalid-feedback">*{errors.employee_id}</div>}
                </Form.Group>
                 <Form.Group className="mb-3">
                  <Form.Label>Overtime Type</Form.Label>
                  <Form.Select
                    name="overtime_type_id"
                    value={formData.overtime_type_id}
                    onChange={handleInputChange}
                    className={errors?.overtime_type_id ? "is-invalid" : ""}
                  >
                    <option value="">Select Type</option>
                    {types.map((emp) => (
                      <option key={emp.id} value={emp.id}>
                        {emp.name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.overtime_type_id && <div className="invalid-feedback">*{errors.overtime_type_id}</div>}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    className={errors?.date ? "is-invalid" : ""}
                  />
                  {errors.date && <div className="invalid-feedback">*{errors.date}</div>}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Hours</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.5"
                    name="hours"
                    value={formData.hours}
                    onChange={handleInputChange}
                    className={errors?.hours ? "is-invalid" : ""}
                  />
                  {errors.hours && <div className="invalid-feedback">*{errors.hours}</div>}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Reason</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="reason"
                    value={formData.reason}
                    onChange={handleInputChange}
                    style={{ minHeight: "100px" }}
                  />
                </Form.Group>
              </Form>
            </Offcanvas.Body>
            <div className="p-3 d-flex justify-content-end border-top">
              <Button variant="secondary me-2" onClick={() => setShowModal(false)}>
                Close
              </Button>
              <Button variant="secondary" onClick={handleSubmit}>
                {isEdit ? "Update" : "Save"}
              </Button>
            </div>
          </Offcanvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OvertimeList;

